import styled from "styled-components";
import { fontSize } from "stylesheetB2b";

export const RouletteContainer = styled.div<{ withBamLayout?: boolean }>`
  position: relative;
  width: 100%;
  height: 100%;
  font-family: Roboto, sans-serif;
  ${({ withBamLayout }) =>
		withBamLayout
			? `
      background: linear-gradient(
   rgb(231 46 92) 0%,   
   rgb(231 46 92 / 50%) 70%, 
   rgb(231 46 92 / 40%) 90% );
    `
			: `
      background: linear-gradient(
      rgb(118 34 178) 0%,
      rgb(118 34 178 / 50%) 80%,
      rgb(118 34 178 / 40%) 90%);
      `};
`;

export const BackArrowContainer = styled.div`
  position: absolute;    
  display: flex;
  align-items: center;
  top: 15px;
  left: 15px;
`;

export const TextTitleWrapper = styled.div`
margin: 10px;
  color: #FFED10;
`;

export const KaraokeTextWrapper = styled.div`
display: flex;
align-items: center;
justify-content: space-between;
margin: 10px 0;
`;

export const KaraokeText = styled.h1`
  color: #FFED10;
  font-size: ${fontSize.XXLarge};
`;

export const RouletteText = styled.h1<{ big?: boolean }>`
font-size: ${({ big }) => (big ? "100px" : fontSize.XXLarge)};
font-weight: bold;
  color: #FFED10;
`;

export const RouletteTittle = styled.h2`
  font-size: 5rem;
  font-weight: bold;
  color: #FFED10;
  margin-bottom: 20px;
`;
